module.exports = __webpack_public_path__ + "img/ic_audio_default.8eab777d.png";